const useUser = () => {
    const user = useSupabaseUser()

    const fetchUserRole = async () => {
        const { data, status, error, refresh } = await useLazyFetch(`/api/users/read/role/${user.value.id}`)

        return { data, status, error, refresh }
    }

    const fetchUserRolePermissions = async (id) => {
        const { data, status, error, refresh } = await useLazyFetch(`/api/users/read/permissions/${id}`)

        return { data, status, error, refresh }
    }

    const fetchUserDetails = async () => {
        const { data, status, error, refresh } = await useLazyFetch(`/api/users/read/admins/details/${user.value.id}`)

        return { data, status, error, refresh }
    }

    const fetchUserOpeners = async () => {
        const { data, status, error, refresh } = await useLazyFetch(`/api/users/read/admins/openers`)

        return { data, status, error, refresh }
    }

    const fetchUserClosers = async () => {
        const { data, status, error, refresh } = await useLazyFetch(`/api/users/read/admins/closers`)

        return { data, status, error, refresh }
    }

    return {
        fetchUserRole,
        fetchUserRolePermissions,
        fetchUserDetails,
        fetchUserOpeners,
        fetchUserClosers
    }
}

export default useUser
